import React, { useState, useEffect, useRef } from 'react'
import { Input, Button, Checkbox, Badge, Tooltip, Radio } from 'antd'
import { SearchOutlined, WarningOutlined } from '@ant-design/icons'
import {  fieldAutoSuggest } from '../../services/crew';
import dayjs from 'dayjs';const HOC = (name, { crewSchedulingPermissions, date: passedDate, crewId: passedCrewId, employees: passedEmployees, fromDate, toDate, onSort, sortConfig, filterUserId } = {}) => {
    const showSpecific = (crewSchedulingPermissions || []).find(
        (f) => f.feature && f.feature.toLowerCase().includes('show specific fields')
    );
const subFind = (needle) =>
        showSpecific?.subFeatures?.find(
            (s) =>
                s?.name &&
                s.name.toString().toLowerCase().includes(needle.toString().toLowerCase())
        );
const includeDispatch = !(subFind('dispatch')?.access === false);
    const includeOnPrem = !(
        subFind('on-prem')?.access === false ||
        subFind('on prem')?.access === false ||
        subFind('onprem')?.access === false
    );
       const FilterDropdown = React.memo(({ title, dataIndex, screen, setSelectedKeys, selectedKeys, confirm, clearFilters, tableFilters, visible }) => {
       const [inputValue, setInputValue] = useState('');
        const [searchText, setSearchText] = useState('');
        const [filterMode, setFilterMode] = useState('include');
        const [isLoading, setIsLoading] = useState(false);
        const [selectedValues, setSelectedValues] = useState(
            Array.isArray(selectedKeys)
                ? selectedKeys.map(s => (typeof s === 'string' && s.startsWith('__exact__') ? s.slice('__exact__'.length) : s))
                : (selectedKeys ? [(typeof selectedKeys === 'string' && selectedKeys.startsWith('__exact__') ? selectedKeys.slice('__exact__'.length) : selectedKeys)] : [])
        );
        const [options, setOptions] = useState([]);
        const debounceRef = useRef(null);
        const minCharsFor = (key) => ['employeesNeeded', 'employeesScheduled', 'noShow', 'difference'].includes(key) ? 1 : 2;
        const dropdownRef = useRef(null);
        const MIN_CHARS = minCharsFor(dataIndex);
        const FILTER_PREFIX = '__filter__';
        const cleanSelectedValues = (vals) => (vals || []).filter((v) => !(typeof v === 'string' && v.startsWith(FILTER_PREFIX)));
   useEffect(() => {
            if (visible === false && dropdownRef.current) {
                setInputValue('');
                setSearchText('');
            }
        }, [visible]);
     useEffect(() => {
            const handleWheel = (e) => {
                if (Math.abs(e.deltaX) > 0) {
                    setInputValue('');
                    setSearchText('');
                }
            };
     const container =
                dropdownRef.current?.closest('.ant-table-wrapper') || window;
               container.addEventListener('wheel', handleWheel, { passive: true });
               return () => {
                container.removeEventListener('wheel', handleWheel);
            };
        }, []);
        useEffect(() => {
            const parseFilterPayload = (selKeys) => {
                if (!selKeys || !Array.isArray(selKeys) || !selKeys.length) return null;
                const first = selKeys[0];
                if (typeof first !== 'string' || !first.startsWith(FILTER_PREFIX)) return null;
                try {
                    return JSON.parse(first.slice(FILTER_PREFIX.length));
                } catch (e) {
                    return null;
                }
            };

            const parsed = parseFilterPayload(selectedKeys);
            if (parsed && Array.isArray(parsed.values)) {
                setFilterMode(parsed.mode || 'include');
                setSelectedValues(cleanSelectedValues(parsed.values.map(String)));
                return;
            }

            setFilterMode('include');
            setSelectedValues(cleanSelectedValues(
                Array.isArray(selectedKeys)
                    ? selectedKeys.map(s => (typeof s === 'string' && s.startsWith('__exact__') ? s.slice('__exact__'.length) : s))
                    : (selectedKeys ? [(typeof selectedKeys === 'string' && selectedKeys.startsWith('__exact__') ? selectedKeys.slice('__exact__'.length) : selectedKeys)] : [])
            ));
        }, [selectedKeys]);

        const normalizeForFilter = (v) => String(v ?? '')
            .toLowerCase()
            .replace(/[\u200B-\u200D\uFEFF]/g, '')
            .trim()
            .replace(/\s+/g, ' ');

        const sanitizeFilters = (filters) => {
            if (!filters) return undefined;
            const cleaned = {};
            Object.entries(filters).forEach(([key, value]) => {
                if (!Array.isArray(value)) return;
                const nonEmpty = value.filter((v) => v !== null && v !== undefined && v !== '');
                if (nonEmpty.length) cleaned[key] = nonEmpty;
            });
            Object.keys(cleaned).forEach((key) => {
                const vals = cleaned[key];
                if (!Array.isArray(vals) || vals.length === 0) return;
                const first = vals[0];
                if (typeof first === 'string' && first.startsWith(FILTER_PREFIX)) {
                    try {
                        const payload = JSON.parse(first.slice(FILTER_PREFIX.length));
                        const mode = payload?.mode || 'include';
                        const values = Array.isArray(payload?.values) ? payload.values : [];
                        const normalizedValues = values
                            .map((v) => normalizeForFilter(v))
                            .filter(Boolean);
                        if (!normalizedValues.length) {
                            delete cleaned[key];
                        } else if (mode === 'exclude') {
                            cleaned[key] = { mode: 'exclude', values: normalizedValues };
                        } else {
                            cleaned[key] = normalizedValues;
                        }
                    } catch (e) {
                        delete cleaned[key];
                    }
                } else {
                    const normalizedValues = vals
                        .map((v) => normalizeForFilter(v))
                        .filter(Boolean);
                    if (normalizedValues.length) {
                        cleaned[key] = normalizedValues;
                    } else {
                        delete cleaned[key];
                    }
                }
            });
            return Object.keys(cleaned).length ? cleaned : undefined;
        };
     const hasOptions = Array.isArray(options) && options.length > 0;
     const resetAll = () => {
            setFilterMode('include');
            setSelectedValues([]);
            setSelectedKeys([]);
            clearFilters();
            confirm();
            setInputValue('');
            setSearchText('');
        };
    const sortSuggestionValues = (values = []) => {
        return [...values].sort((a, b) =>
            String(a).localeCompare(String(b), undefined, { sensitivity: 'base', numeric: true })
        );
    };

    const toUniqueSortedOptions = (values = []) => {
        const unique = [...new Set((values || []).map((s) => String(s)).filter(Boolean))];
        return sortSuggestionValues(unique);
    };
 useEffect(() => {
            if (Array.isArray(selectedValues) && selectedValues.length) {
                setOptions((prev) => {
                    const merged = [...new Set([...(prev || []), ...selectedValues.map(String)])];
                    return sortSuggestionValues(merged);
                });
            }
        }, [JSON.stringify(selectedValues)]);
   const PREFIX = '__exact__';
        const stripPrefix = (s) => (typeof s === 'string' && s.startsWith(PREFIX) ? s.slice(PREFIX.length) : s);
        const displaySelectedFromProp = (selKeys) => {
            if (!selKeys) return '';
            if (Array.isArray(selKeys) && selKeys.length) return stripPrefix(selKeys[0]);
            return stripPrefix(selKeys);
        };
  return (
            <div ref={dropdownRef} style={{ padding: "8px", width: '260px' }}>
                <Input
                    placeholder={`Search ${title}`}
                    allowClear
                    value={inputValue}
                    onClear={() => {
                        setInputValue('');
                        setSearchText('');
                        setOptions(Array.isArray(selectedValues) && selectedValues.length ? toUniqueSortedOptions(selectedValues) : []);
                    }}
                    onChange={(e) => {
                        const value = e.target.value;
                         setInputValue(value);
                         if (debounceRef.current) clearTimeout(debounceRef.current);
                        debounceRef.current = setTimeout(() => {
                            setSearchText(value);
                            if ((value || '').length < MIN_CHARS) {
                                setOptions(Array.isArray(selectedValues) && selectedValues.length ? toUniqueSortedOptions(selectedValues) : []);
                                setIsLoading(false);
                                return;
                            }
                            setIsLoading(true);
                            const formattedDate = passedDate ? (dayjs.isDayjs(passedDate) ? dayjs(passedDate).format('YYYY-MM-DD') : String(passedDate)) : undefined;
                            const base = { key: dataIndex, searchText: value };
                            if (formattedDate) base.date = formattedDate;
                            if (passedCrewId) base.crewId = passedCrewId;
                            const payload = screen ? { ...base, screen } : base;
                            if (filterUserId) payload.filterUserId = filterUserId;
                            const cleanedFilters = sanitizeFilters(tableFilters);
                            const filterObj = cleanedFilters ? JSON.parse(JSON.stringify(cleanedFilters)) : {};
                            if (fromDate) filterObj.fromDate = dayjs.isDayjs(fromDate) ? fromDate.format('YYYY-MM-DD') : fromDate;
                            if (toDate) filterObj.toDate = dayjs.isDayjs(toDate) ? toDate.format('YYYY-MM-DD') : toDate;
                            if (Object.keys(filterObj).length > 0) payload.filters = JSON.stringify(filterObj);
                            fieldAutoSuggest(payload)
                                .then(res => {
                                    const data = res?.data ?? res;
                                    let suggestions = Array.isArray(data?.suggestions)
                                        ? data.suggestions.map(s => s?.value).filter(Boolean)
                                        : [];
                                 if (Array.isArray(passedEmployees) && passedEmployees.length > 0) {
                                        const employeeValues = passedEmployees.map(emp => String(emp[dataIndex])).filter(Boolean);
                                        if (employeeValues.length > 0) {
                                            suggestions = suggestions.filter(s => employeeValues.includes(String(s)));
                                        }
                                    }
                                    const merged = Array.isArray(selectedValues) && selectedValues.length ? [...suggestions, ...selectedValues] : suggestions;
                                                    setOptions(toUniqueSortedOptions(merged));
                                })
                                .catch(err => {
                                    console.warn('fieldAutoSuggest error:', err);
                                })
                                .finally(() => {
                                    setIsLoading(false);
                                });
                        }, 300);
                    }}
                    style={{ width: "100%", marginBottom: hasOptions ? 8 : 0 }}
                />
              {(hasOptions || (searchText.length >= MIN_CHARS && options.length === 0)) && (
                    <div style={{ maxHeight: 240, overflowY: 'auto', overflowX: 'auto' }}>
                        {(() => {
                            if (isLoading) {
                                return <div style={{ padding: '8px', textAlign: 'center', color: '#1890ff' }}>Loading...</div>;
                            }
                            const filtered = options.filter(opt => opt?.toString().toLowerCase().includes(searchText.toLowerCase()));
                            const displayList = toUniqueSortedOptions([...(filtered || []), ...(selectedValues || [])])
                                .filter((v) => !(typeof v === 'string' && v.startsWith(FILTER_PREFIX)));
                            if (displayList.length === 0 && searchText.length >= MIN_CHARS) {
                                return <div style={{ padding: '8px', textAlign: 'center', color: '#999' }}>No data</div>;
                            }
                              return displayList.map(option => (
                                <div key={option}>
                                    <Checkbox
                                        checked={selectedValues.includes(option)}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            const updated = checked ? [...selectedValues, option] : selectedValues.filter(v => v !== option);
                                            setSelectedValues(updated);
                                        }}
                                    >{option}</Checkbox>
                                </div>
                            ));
                        })()}
                    </div>
                )}
              <div style={{ marginTop: 8 }}>
                    <Radio.Group
                        size="small"
                        value={filterMode}
                        onChange={(e) => setFilterMode(e.target.value)}
                        style={{ width: '100%', display: 'flex' }}
                    >
                        <Radio.Button value="include" style={{ flex: 1, textAlign: 'center' }}>Include</Radio.Button>
                        <Radio.Button value="exclude" style={{ flex: 1, textAlign: 'center' }}>Exclude</Radio.Button>
                    </Radio.Group>
                </div>
                <div style={{ marginTop: "8px", display: 'flex', gap: 8, width: '100%' }}>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                            const payload = { mode: filterMode, values: selectedValues };
                            try { setSelectedKeys([FILTER_PREFIX + JSON.stringify(payload)]); } catch (e) { setSelectedKeys([]); }
                            confirm();
                        }}
                        style={{ flex: 1 }}
                    >
                        Apply
                    </Button>
                    <Button size="small" onClick={resetAll} style={{ flex: 1 }}>Reset</Button>
                </div>
            </div>
        );
    });
const getFilterDropdown = (dataIndex,title, screen) => (props) => (
        <FilterDropdown {...props} title={title} dataIndex={dataIndex} screen={screen} />
    );
const getSearchIcon = (dataIndex, onSort, sortConfig) => (filtered) => {
        return (
            <Button
                style={{
                    backgroundColor: "transparent",
                    border: "none",
                    boxShadow: "none",
                    width: "5px",
                    cursor: "pointer",
                }}
            >
                <Badge dot={!!filtered} offset={[0, 0]}>
                    <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
                </Badge>
            </Button>
        );
    };
const getOnSearch = (dataIndex) => (value, record) => {
    const normalizeForFilter = (v) => String(v ?? '').toLowerCase().replace(/[\u200B-\u200D\uFEFF]/g, '').trim().replace(/\s+/g, ' ');
       let recVal;
        const raw = record[dataIndex];
        if (typeof raw === 'boolean') {
            recVal = raw ? 'yes' : ''; // falsy values display as empty string
        } else {
            recVal = normalizeForFilter(raw);
        }
       try {
            if (typeof value === 'string' && value.startsWith('__filter__')) {
                const payload = JSON.parse(value.slice('__filter__'.length));
                const mode = payload?.mode || 'include';
                const values = Array.isArray(payload?.values) ? payload.values : [];
                const normalized = values.map(v => normalizeForFilter(v));
                if (!normalized.length) return true;
                if (mode === 'exclude') {
                    return !normalized.includes(recVal);
                }
                return normalized.includes(recVal);
            }
            if (typeof value === 'string' && value.startsWith('__exact__')) {
                return recVal === normalizeForFilter(value.slice('__exact__'.length));
            }
            return recVal.includes(normalizeForFilter(value));
        } catch (e) {
            return false;
        }
    };
const getRender = (textKey = "name") => (text, record) => {
        const needed = Number(record.numEmployees) || 0;
        const scheduled = Number(record.scheduleEmployee) || 0;
        let color = "";
        if (scheduled > needed) color = "#1677ff"; // blue
        else if (scheduled < needed) color = "red";
        else if (scheduled === needed && needed !== 0) color = "#fadb14"; // yellow
        return <span style={{ color }}>{record[textKey]}</span>;
    };
 const formatTime = (timeValue) => {
        if (!timeValue) return "";
        try {
            if (typeof timeValue === 'string' && timeValue.includes('T')) {
                return dayjs(timeValue).format('HH:mm');
            }
            if (typeof timeValue === 'string') {
                return timeValue;
            }
            return dayjs(timeValue).format('HH:mm');
        } catch (e) {
            return timeValue;
        }
    };
const createTitleWithSort = (title, dataIndex, onSort, sortConfig) => {
        if (!onSort) {
            return (
                <Tooltip title={title} placement="top" overlayStyle={{ pointerEvents: "none" }}>
                    <span>{title}</span>
                </Tooltip>
            );
        }
    const currentOrder = sortConfig?.field === dataIndex ? sortConfig?.order : null;
 const handleClick = () => {
            let nextOrder;
            if (!currentOrder) {
                nextOrder = 'ascend';
            } else if (currentOrder === 'ascend') {
                nextOrder = 'descend';
            } else {
                nextOrder = null;
            }
            onSort(dataIndex, nextOrder);
        };

        return (
            <Tooltip title={title} placement="top" overlayStyle={{ pointerEvents: "none" }}>
                <span
                    onClick={handleClick}
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                >
                    {title}
                    {currentOrder === 'ascend' && ' ↑'}
                    {currentOrder === 'descend' && ' ↓'}
                </span>
            </Tooltip>
        );
    };
const employeeColumns =
        [
            {
                title: createTitleWithSort("Employee ID", "id", onSort, sortConfig),
                dataIndex: "id",
                key: "id",
                size: 'small',
                filterDropdown: getFilterDropdown('id', "Employee ID"),
                filterIcon: getSearchIcon('id', onSort, sortConfig),
                onFilter: getOnSearch('id'),
                render: getRender('id'),
            },
            {
                title: createTitleWithSort("SSN4", "ssn4", onSort, sortConfig),
                dataIndex: "ssn4",
                key: "ssn4",
                size: 'small',
                filterDropdown: getFilterDropdown('ssn4', "SSN4"),
                filterIcon: getSearchIcon('ssn4', onSort, sortConfig),
                onFilter: getOnSearch('ssn4'),
                render: getRender('ssn4'),
            },
            {
                title: createTitleWithSort("Union", "union", onSort, sortConfig),
                dataIndex: "union",
                key: "union",
                filterDropdown: getFilterDropdown('union', "Union"),
                filterIcon: getSearchIcon('union', onSort, sortConfig),
                onFilter: getOnSearch('union'),
                render: getRender('union'),
            },
            {
                title: createTitleWithSort("Employee Name", "name", onSort, sortConfig),
                dataIndex: "name",
                key: "name",
                size: 'small',
                filterDropdown: getFilterDropdown('name', "Employee Name"),
                filterIcon: getSearchIcon('name', onSort, sortConfig),
                onFilter: getOnSearch('name'),
                render: getRender('name'),
            },
            {
                title: createTitleWithSort("Union Stat", "unionStat", onSort, sortConfig),
                dataIndex: "unionStat",
                key: "unionStat",
                filterDropdown: getFilterDropdown('unionStat', "Union Stat"),
                filterIcon: getSearchIcon('unionStat', onSort, sortConfig),
                onFilter: getOnSearch('unionStat'),
                render: getRender('unionStat'),
            },
            {
                title: createTitleWithSort("Trade Class/Skill Set", "trade", onSort, sortConfig),
                dataIndex: "trade",
                key: "trade",
                size: 'small',
                filterDropdown: getFilterDropdown('trade', "Trade Class/Skill Set"),
                filterIcon: getSearchIcon('trade', onSort, sortConfig),
                onFilter: getOnSearch('trade'),
                render: getRender('trade'),
            },
            {
                title: createTitleWithSort("Sched Stat", "schedStat", onSort, sortConfig),
                dataIndex: "schedStat",
                key: "schedStat",
                filterDropdown: getFilterDropdown('schedStat', "Sched Stat"),
                filterIcon: getSearchIcon('schedStat', onSort, sortConfig),
                onFilter: getOnSearch('schedStat'),
                render: getRender('schedStat'),
            },
            {
                title: createTitleWithSort("Member ID", "memberId", onSort, sortConfig),
                dataIndex: "memberId",
                key: "memberId",
                size: 'small',
                filterDropdown: getFilterDropdown('memberId', "Member ID"),
                filterIcon: getSearchIcon('memberId', onSort, sortConfig),
                onFilter: getOnSearch('memberId'),
                render: getRender('memberId'),
            },
            {
                title: createTitleWithSort("Phone no.", "phoneNo", onSort, sortConfig),
                dataIndex: "phoneNo",
                key: "phoneNo",
                size: 'small',
                filterDropdown: getFilterDropdown('phoneNo', "Phone no."),
                filterIcon: getSearchIcon('phoneNo', onSort, sortConfig),
                onFilter: getOnSearch('phoneNo'),
                render: getRender('phoneNo'),
            },
            ...(includeOnPrem ? [
                {
                    title: createTitleWithSort("On Prem", "onPremises", onSort, sortConfig),
                    dataIndex: "onPremises",
                    key: "onPremises",
                    filterDropdown: getFilterDropdown('onPremises', "On Prem"),
                    filterIcon: getSearchIcon('onPremises', onSort, sortConfig),
                    onFilter: getOnSearch('onPremises'),
                    render: (_, record) => record?.onPremises ? "Yes" : ""

                }
            ] : []),
            {
                title: createTitleWithSort("Current Crew Lead", "currentCrewLead", onSort, sortConfig),
                dataIndex: "currentCrewLead",
                key: "currentCrewLead",
                filterDropdown: getFilterDropdown('currentCrewLead', "Current Crew Lead"),
                filterIcon: getSearchIcon('currentCrewLead', onSort, sortConfig),
                onFilter: getOnSearch('currentCrewLead'),
                render: getRender('currentCrewLead'),
            },
            {
                title: createTitleWithSort("Reference", "reference", onSort, sortConfig),
                dataIndex: "reference",
                key: "reference",
                filterDropdown: getFilterDropdown('reference', "Reference"),
                filterIcon: getSearchIcon('reference', onSort, sortConfig),
                onFilter: getOnSearch('reference'),
                render: getRender('reference'),
            },
            {
                title: createTitleWithSort("Next Scheduled", "nextScheduled", onSort, sortConfig),
                dataIndex: "nextScheduled",
                key: "nextScheduled",
                filterDropdown: getFilterDropdown('nextScheduled', "Next Scheduled"),
                filterIcon: getSearchIcon('nextScheduled', onSort, sortConfig),
                onFilter: getOnSearch('nextScheduled'),
                render: getRender('nextScheduled'),
            },
            {
                title: createTitleWithSort("Multi Scheduled", "multischeduled", onSort, sortConfig),
                dataIndex: "multischeduled",
                key: "multischeduled",
                align: 'center',
                filterDropdown: getFilterDropdown('multischeduled', "Multi Scheduled"),
                filterIcon: getSearchIcon('multischeduled', onSort, sortConfig),
                onFilter: getOnSearch('multischeduled'),
                render: (text, record) => {
                    return record?.multischeduled === true ? (
                        <   WarningOutlined style={{ color: "#faad14", fontSize: 16 }} />
                    ) : null;
                },

            },
            {
                title: createTitleWithSort("Current Crew", "currentCrew", onSort, sortConfig),
                dataIndex: "currentCrew",
                key: "currentCrew",
                size: 'small',
                filterDropdown: getFilterDropdown('currentCrew', "Current Crew"),
                filterIcon: getSearchIcon('currentCrew', onSort, sortConfig),
                onFilter: getOnSearch('currentCrew'),
                render: getRender('currentCrew'),
            },
            {
                title: createTitleWithSort("Owner", "owner", onSort, sortConfig),
                dataIndex: "owner",
                key: "owner",
                filterDropdown: getFilterDropdown('owner', "Owner"),
                filterIcon: getSearchIcon('owner', onSort, sortConfig),
                onFilter: getOnSearch('owner'),
                render: getRender('owner'),
            },
            {
                title: createTitleWithSort("Crew Lead", "crewLead", onSort, sortConfig),
                dataIndex: "crewLead",
                key: "crewLead",
                filterDropdown: getFilterDropdown('crewLead', "Crew Lead"),
                filterIcon: getSearchIcon('crewLead', onSort, sortConfig),
                onFilter: getOnSearch('crewLead'),
                render: getRender('crewLead'),
            },
            {
                title: createTitleWithSort("Start", "start", onSort, sortConfig),
                dataIndex: "start",
                key: "start",
                filterDropdown: getFilterDropdown('start', "Start"),
                filterIcon: getSearchIcon('start', onSort, sortConfig),
                onFilter: getOnSearch('start'),
                render: getRender('start'),
            },
            {
                title: createTitleWithSort("End", "end", onSort, sortConfig),
                dataIndex: "end",
                key: "end",
                filterDropdown: getFilterDropdown('end', "End"),
                filterIcon: getSearchIcon('end', onSort, sortConfig),
                onFilter: getOnSearch('end'),
                render: getRender('end'),
            },
            {
                title: createTitleWithSort("Event", "event", onSort, sortConfig),
                dataIndex: "event",
                key: "event",
                filterDropdown: getFilterDropdown('event', "Event"),
                filterIcon: getSearchIcon('event', onSort, sortConfig),
                onFilter: getOnSearch('event'),
                render: getRender('event'),
            },
            {
                title: createTitleWithSort("Event Description", "eventDescription", onSort, sortConfig),
                dataIndex: "eventDescription",
                key: "eventDescription",
                filterDropdown: getFilterDropdown('eventDescription', "Event Description"),
                filterIcon: getSearchIcon('eventDescription', onSort, sortConfig),
                onFilter: getOnSearch('eventDescription'),
                render: getRender('eventDescription'),
            },
            {
                title: createTitleWithSort("Task", "task", onSort, sortConfig),
                dataIndex: "task",
                key: "task",
                size: 'small',
                filterDropdown: getFilterDropdown('task', "Task"),
                filterIcon: getSearchIcon('task', onSort, sortConfig),
                onFilter: getOnSearch('task'),
                render: getRender('task'),
            }, //venue
            {
                title: createTitleWithSort("Venue", "venue", onSort, sortConfig),
                dataIndex: "venue",
                key: "venue",
                size: 'small',
                filterDropdown: getFilterDropdown('venue', "Venue"),
                filterIcon: getSearchIcon('venue', onSort, sortConfig),
                onFilter: getOnSearch('venue'),
                render: getRender('venue'),
            },
            {
                title: createTitleWithSort("PayScale", "payScale", onSort, sortConfig),
                dataIndex: "payScale",
                key: "payScale",
                filterDropdown: getFilterDropdown('payScale', "PayScale"),
                filterIcon: getSearchIcon('payScale', onSort, sortConfig),
                onFilter: getOnSearch('payScale'),
                render: getRender('payScale'),
            },
            {
                title: createTitleWithSort("Payscale Description", "payscaleDescription", onSort, sortConfig),
                dataIndex: "payscaleDescription",
                key: "payscaleDescription",
                filterDropdown: getFilterDropdown('payscaleDescription', "Payscale Description"),
                filterIcon: getSearchIcon('payscaleDescription', onSort, sortConfig),
                onFilter: getOnSearch('payscaleDescription'),
                render: getRender('payscaleDescription'),
            },//premium
            {
                title: createTitleWithSort("Premium", "premium", onSort, sortConfig),
                dataIndex: "premium",
                key: "premium",

                filterDropdown: getFilterDropdown('premium', "Premium", 'crew'),
                filterIcon: getSearchIcon('premium', onSort, sortConfig),
                onFilter: getOnSearch('premium'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Work Rule Transfer", "workRuleTransfer", onSort, sortConfig),
                dataIndex: "workRuleTransfer",
                key: "workRuleTransfer",
                filterDropdown: getFilterDropdown('workRuleTransfer', "Work Rule Transfer"),
                filterIcon: getSearchIcon('workRuleTransfer', onSort, sortConfig),
                onFilter: getOnSearch('workRuleTransfer'),
                render: getRender('workRuleTransfer'),
            },
            {
                title: createTitleWithSort("Supervisor", "supervisor", onSort, sortConfig),
                dataIndex: "supervisor",
                key: "supervisor",
                filterDropdown: getFilterDropdown('supervisor',"Supervisor"),
                filterIcon: getSearchIcon('supervisor', onSort, sortConfig),
                onFilter: getOnSearch('supervisor'),
                render: getRender('supervisor'),
            },
            {
                title: createTitleWithSort("Assigned At", "assignedAt", onSort, sortConfig),
                dataIndex: "assignedAt",
                key: "assignedAt",

                render: (text) => {
                    if (!text) return "";
                    const formattedDate = dayjs(text).format("MM-DD-YYYY HH:mm");
                    return <span>{formattedDate}</span>;
                },
            },
            {
                title: createTitleWithSort("Scheduled by", "scheduledBy", onSort, sortConfig),
                dataIndex: "scheduledBy",
                key: "scheduledBy",
                filterDropdown: getFilterDropdown('scheduledBy', "Scheduled by"),
                filterIcon: getSearchIcon('scheduledBy', onSort, sortConfig),
                onFilter: getOnSearch('scheduledBy'),
                render: getRender('scheduledBy'),
            },
            ...(includeDispatch ? [
                // {
                //     title: createTitleWithSort("Dispatched", "dispatched", onSort, sortConfig),
                //     dataIndex: "dispatched",
                //     key: "dispatched",
                //     filterDropdown: getFilterDropdown('dispatched'),
                //     filterIcon: getSearchIcon('dispatched', onSort, sortConfig),
                //     onFilter: getOnSearch('dispatched'),
                //     render: (value) => (value ? "Yes" : ""),

                // }

                {
  title: createTitleWithSort(
    "Dispatched",
    "dispatched",
    onSort,
    sortConfig
  ),
  dataIndex: "dispatched",
  key: "dispatched",

  filterDropdown: getFilterDropdown('dispatched', "Dispatched"),

  filterIcon: getSearchIcon(
    'dispatched',
    onSort,
    sortConfig
  ),

  onFilter: getOnSearch('dispatched'),

  render: (value, record) => {

    // ✅ If Layoff → show No
    if (record?.currentCrew === "Layoff") {
      return "";
    }

       // ✅ Otherwise normal behavior
       return value ? "Yes" : "";
  }

}
            ] : []),
            {
                title: createTitleWithSort("System Message", "systemMessaged", onSort, sortConfig),
                dataIndex: "systemMessaged",
                key: "systemMessaged",
                filterDropdown: getFilterDropdown('systemMessaged', "System Message"),
                filterIcon: getSearchIcon('systemMessaged', onSort, sortConfig),
                onFilter: getOnSearch('systemMessaged'),
                render: getRender('systemMessaged'),
            },

        ];

const crewColumns =
        [
            {
                title: "",
                dataIndex: "status",
                key: "status",
                fixed: 'left',
                render: (_, record) => {
                    const needed = Number(record.employeesNeeded) || 0;
                    const scheduled = Number(record.employeesScheduled) || 0;

                    const diff = scheduled - needed;
                    let color = "#d9d9d9";
                    color = diff < 0 ? "red" : "green";
return (
                        <span>
                            <span style={{
                                display: "inline-block",
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                background: color,
                                marginRight: 8,
                                border: "1px solid #d9d9d9",
                            }}
                            />
                        </span>
                    );
                },
            },
            {
                title: createTitleWithSort("Crew Name", "crewName", onSort, sortConfig),
                dataIndex: "crewName",
                key: "crewName",
                width: 200,
                onCell: () => ({ style: { borderRight: "2px solid #f0f0f0" } }),
                filterDropdown: getFilterDropdown('crewName', "Crew Name", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('crewName'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Event", "eventName", onSort, sortConfig),
                dataIndex: "eventName",
                key: "eventName",
                width: 180,
                onCell: () => ({ style: { borderRight: "2px solid #f0f0f0" } }),
                filterDropdown: getFilterDropdown('eventName', "Event",  'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('eventName'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Crew Owner", "crewOwner", onSort, sortConfig),
                dataIndex: "crewOwner",
                key: "crewOwner",
                width: 180,
                onCell: () => ({ style: { borderRight: "2px solid #f0f0f0" } }),
                filterDropdown: getFilterDropdown('crewOwner', "Crew Owner", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('crewOwner'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Needed", "employeesNeeded", onSort, sortConfig),
                dataIndex: "employeesNeeded",
                key: "employeesNeeded",
                width: 120,
                align: "center",
                filterDropdown: getFilterDropdown('employeesNeeded', "Needed", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('employeesNeeded'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Scheduled", "employeesScheduled", onSort, sortConfig),
                dataIndex: "employeesScheduled",
                key: "employeesScheduled",
                width: 130,
                align: "center",
                filterDropdown: getFilterDropdown('employeesScheduled', "Scheduled", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('employeesScheduled'),
                render: (val, record) => {
                    return Array.isArray(record?.employeesToAssign) ? record.employeesToAssign.length : val ?? "-";
                },
            },
            {
                title: createTitleWithSort("Difference", "difference", onSort, sortConfig),
                key: "difference",
                width: 120,
                align: "center",

                render: (_, record) => {
                    const needed = Number(record.employeesNeeded) || 0;
                    const scheduled = Number(record.employeesScheduled) || 0;
                    const diff = scheduled - needed;
                    return diff === 0 ? 0 : <span>{diff}</span>;
                },
            },
            {
                title: createTitleWithSort("No Show", "noShow", onSort, sortConfig),
                dataIndex: "noShow",
                key: "noShow",
                align: "center",
                filterDropdown: getFilterDropdown('noShow', "No Show", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('noShow'),
                // render: (text) => <span>{text}</span>,
          render: (text, record) => {
    const now = dayjs().format("HH:mm");

    const { startTime, endTime } = record;

    let showNoShow = false;

    if (startTime <= endTime) {
        // Normal shift
        showNoShow = now >= startTime && now <= endTime;
    } else {
        // Overnight shift (crosses midnight)
        showNoShow = now >= startTime || now <= endTime;
    }

    return <span>{showNoShow ? text : ""}</span>;
}
            },
            {
                title: createTitleWithSort("Task", "task", onSort, sortConfig),
                dataIndex: "task",
                key: "task",
                filterDropdown: getFilterDropdown('task', "Task", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('task'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Venue", "venue", onSort, sortConfig),
                dataIndex: "venue",
                key: "venue",
                filterDropdown: getFilterDropdown('venue', "Venue", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('venue'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Payscale", "payScale", onSort, sortConfig),
                dataIndex: "payScale",
                key: "payScale",
                filterDropdown: getFilterDropdown('payScale', "Payscale", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('payScale'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Supervisor", "supervisor", onSort, sortConfig),
                dataIndex: "supervisor",
                key: "supervisor",
                filterDropdown: getFilterDropdown('supervisor', "Supervisor", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('supervisor'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Crew Lead", "crewLead", onSort, sortConfig),
                dataIndex: "crewLead",
                key: "crewLead",
                filterDropdown: getFilterDropdown('crewLead', "Crew Lead", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('crewLead'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Premium", "premium", onSort, sortConfig),
                dataIndex: "premium",
                key: "premium",
                filterDropdown: getFilterDropdown('premium', "Premium", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('premium'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Event Description", "eventDescription", onSort, sortConfig),
                dataIndex: "eventDescription",
                key: "eventDescription",
                width: 200,
                filterDropdown: getFilterDropdown('eventDescription', "Event Description", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('eventDescription'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Work Rule Transfer", "workRuleTransfer", onSort, sortConfig),
                dataIndex: "workRuleTransfer",
                key: "workRuleTransfer",
                width: 200,
                filterDropdown: getFilterDropdown('workRuleTransfer', "Work Rule Transfer", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('workRuleTransfer'),
                render: (text) => <span>{text}</span>,
            },
            {
                title: createTitleWithSort("Start", "startTime", onSort, sortConfig),
                dataIndex: "startTime",
                key: "startTime",
                // width: 120,
                filterDropdown: getFilterDropdown('startTime', "Start", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('startTime'),
                render: (_, record) => {
                    const scheduleIn = record?.employeesToAssign?.[0]?.scheduleIn;
                    return <span>{scheduleIn || formatTime(record.startTime)}</span>;
                },
            },
            {
                title: createTitleWithSort("End", "endTime", onSort, sortConfig),
                dataIndex: "endTime",
                key: "endTime",
                filterDropdown: getFilterDropdown('endTime', "End", 'crew'),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('endTime'),
                render: (_, record) => {
                    const scheduleOut = record?.employeesToAssign?.[0]?.scheduleOut;
                    return <span>{scheduleOut || formatTime(record.endTime)}</span>;
                },
            },
        ];

    const employeeScheduleColumns = employeeColumns.filter(col => ['name', 'id', 'start', 'schedStat', 'start', 'end', 'currentCrew', 'currentCrewLead', 'event', 'eventDescription', 'task', 'venue', 'payScale', 'payscaleDescription', 'premium', 'onPremises', 'workRuleTranfser', 'scheduledBy', 'assignedAt'].includes(col.dataIndex));

    const templateColumns = (options = {}) =>
        [
            {
                title: createTitleWithSort('Crew template name', 'crewTemplateName', onSort, sortConfig),
                dataIndex: 'crewTemplateName',
                key: 'crewTemplateName',
                fixed: 'left',
                filterDropdown: getFilterDropdown('crewTemplateName', 'Crew template name', options.crewTemplateNameOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('crewTemplateName'),
                render: getRender('crewTemplateName'),
            },
            {
                title: createTitleWithSort('Crew lead', 'crewLead', onSort, sortConfig),
                dataIndex: 'crewLead',
                key: 'crewLead',
                filterDropdown: getFilterDropdown('crewLead', 'Crew lead', options.crewLeadOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('crewLead'),
                render: getRender('crewLead'),
            },
            {
                title: createTitleWithSort('Supervisor', 'supervisor', onSort, sortConfig),
                dataIndex: 'supervisor',
                key: 'supervisor',
                filterDropdown: getFilterDropdown('supervisor', 'Supervisor', options.supervisorOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('supervisor'),
                render: getRender('supervisor'),
            },
            {
                title: createTitleWithSort('Venue', 'venue', onSort, sortConfig),
                dataIndex: 'venue',
                key: 'venue',
                filterDropdown: getFilterDropdown('venue', 'Venue', options.venueOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('venue'),
                render: getRender('venue'),
            },
            {
                title: createTitleWithSort('Pay Scale', 'payScale', onSort, sortConfig),
                dataIndex: 'payScale',
                key: 'payScale',
                filterDropdown: getFilterDropdown('payScale', 'Pay Scale', options.payScaleOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('payScale'),
                render: getRender('payScale'),
            },
            {
                title: createTitleWithSort('Task', 'task', onSort, sortConfig),
                dataIndex: 'task',
                key: 'task',
                filterDropdown: getFilterDropdown('task', 'Task', options.taskOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('task'),
                render: getRender('task'),
            },
            {
                title: createTitleWithSort('Premium', 'premium', onSort, sortConfig),
                dataIndex: 'premium',
                key: 'premium',
                filterDropdown: getFilterDropdown('premium', 'Premium', options.premiumOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('premium'),
                render: getRender('premium'),
            },
            {
                title: createTitleWithSort('Event', 'eventName', onSort, sortConfig),
                dataIndex: 'eventName',
                key: 'eventName',
                filterDropdown: getFilterDropdown('eventName', 'Event', options.eventOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('eventName'),
                render: getRender('eventName'),
            },
            {
                title: createTitleWithSort('Work Rule Transfer', 'workRuleTransfer', onSort, sortConfig),
                dataIndex: 'workRuleTransfer',
                key: 'workRuleTransfer',
                filterDropdown: getFilterDropdown('workRuleTransfer', 'Work Rule Transfer', options.workRuleTransferOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('workRuleTransfer'),
                render: getRender('workRuleTransfer'),
            },
            {
                title: createTitleWithSort('Start', 'startTime', onSort, sortConfig),
                dataIndex: 'startTime',
                key: 'startTime',
                filterDropdown: getFilterDropdown('startTime', 'Start', options.startTimeOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('startTime'),
                render: getRender('startTime'),
            },
            {
                title: createTitleWithSort('End', 'endTime', onSort, sortConfig),
                dataIndex: 'endTime',
                key: 'endTime',
                filterDropdown: getFilterDropdown('endTime', 'End', options.endTimeOptions || []),
                filterIcon: getSearchIcon(),
                onFilter: getOnSearch('endTime'),
                render: getRender('endTime'),
            },
        ]
if (name === "employee") return employeeColumns;
    if (name === "crew") return crewColumns;
    if (name === "employeeSchedule") return employeeScheduleColumns;
    if (name === "template") return templateColumns;
}
export const getFilterDropdown = (dataIndex, options = []) => ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    if (!Array.isArray(options) || options.length === 0) {
        return (
            <div style={{ padding: "8px" }}>
                <Input
                    placeholder={`Type 3+ characters to search ${dataIndex}`}
                    value={selectedKeys?.[0] || ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        setSelectedKeys(value ? [value] : []);
                    }}
                    onPressEnter={() => { if (selectedKeys?.[0]) confirm(); }}
                    onClear={() => { /* preserve previous selection semantics; user can Reset explicitly */ }}
                    allowClear
                    style={{ width: "200px", display: "block" }}
                />
                <div style={{ marginTop: 8, display: 'flex', gap: 8 }}>
                    <Button type="primary" size="small" onClick={() => { if (selectedKeys?.[0]) { setSelectedKeys([selectedKeys[0]]); confirm(); } }} style={{ marginRight: 8 }}>Apply</Button>
                    <Button size="small" onClick={() => { setSelectedKeys([]); clearFilters(); confirm(); }}>Reset</Button>
                </div>
            </div>
        );
    }
  const PREFIX = '__exact__';
    const strip = (s) => (typeof s === 'string' && s.startsWith(PREFIX) ? s.slice(PREFIX.length) : s);
    const selected = selectedKeys || [];
    const selectedStripped = Array.isArray(selected) ? selected.map(strip) : (selected ? [strip(selected)] : []);
    return (
        <div style={{ padding: "8px" }}>
            {options.map(option => (
                <div key={option}>
                    <Checkbox
                        checked={selectedStripped.includes(option)}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            const updated = checked ? [...selectedStripped, option] : selectedStripped.filter(v => v !== option);
                            try { setSelectedKeys(updated.map(v => PREFIX + v)); } catch (err) { setSelectedKeys(updated); }
                        }}
                    >{option}</Checkbox>
                </div>
            ))}
            <div style={{ marginTop: "8px" }}>
                <Button type="primary" size="small" onClick={() => confirm()} style={{ marginRight: "8px" }}>Apply</Button>
                <Button size="small" onClick={() => { setSelectedKeys([]); clearFilters(); confirm(); }}>Reset</Button>
            </div>
        </div>
    );
};
export const getSearchIcon = () => (filtered) => (
    <span style={{ color: filtered ? '#1677ff' : undefined }}>
        <SearchOutlined style={{ fontSize: 16 }} />
    </span>
);
export const getOnSearch = (dataIndex) => (value, record) => {
    const normalizeForFilter = (v) => String(v ?? '').toLowerCase().replace(/[\u200B-\u200D\uFEFF]/g, '').trim().replace(/\s+/g, ' ');
    const recVal = normalizeForFilter(record[dataIndex]);
    try {
        if (typeof value === 'string' && value.startsWith('__filter__')) {
            const payload = JSON.parse(value.slice('__filter__'.length));
            const mode = payload?.mode || 'include';
            const values = Array.isArray(payload?.values) ? payload.values : [];
            const normalized = values.map(v => normalizeForFilter(v));
            if (!normalized.length) return true;
            if (mode === 'exclude') {
                return !normalized.includes(recVal);
            }
            return normalized.includes(recVal);
        }
        if (typeof value === 'string' && value.startsWith('__exact__')) {
            return recVal === normalizeForFilter(value.slice('__exact__'.length));
        }
        return recVal.includes(normalizeForFilter(value));
    } catch (e) {
        return false;
    }
};
export const getRender = (textKey = "name") => (text, record) => <span>{record[textKey]}</span>;
export default HOC;
